export default __webpack_public_path__ + "static/media/naslovna3.1fb577f4.png";